import { animate, animateChild, group, query, stagger, style, transition, trigger } from '@angular/animations';

export const content_enter_up = [
    style({ transform: 'translateY(30px)' }),
    animate('450ms 400ms cubic-bezier(0.42, 0, 1, 1)', style({ transform: 'translateY(0)' })),
];

export const content_leave_dn = [
    style({ transform: 'translateY(0)' }),
    animate('300ms cubic-bezier(0.42, 0, 0.58, 1)', style({ transform: 'translateY(50px)' })),
];

export const header_enter_up = [
    style({ transform: 'translateY(50px)' }),
    animate('450ms 400ms cubic-bezier(0.42, 0, 1, 1)', style({ transform: 'translateY(0)' })),
];

export const header_leave_dn = [
    style({ transform: 'translateY(0)' }),
    animate('300ms cubic-bezier(0.42, 0, 0.58, 1)', style({ transform: 'translateY(30px)' })),
];

export const routeTransitionAnimation = trigger('routerTransition', [
    transition('* => noAnimate', [query('@*', animateChild(), { optional: true })]),
    transition('noAnimate => *', [query('@*', animateChild(), { optional: true })]),

    transition('* => *', [
        style({ position: 'relative' }),
        query(':leave', [style({ position: 'absolute', width: '100%' })], { optional: true }),
        query(':enter', [style({ position: 'fixed', width: '100%' })], { optional: true }),
        group([
            query(
                ':enter',
                group([
                    query('@*', animateChild(), { optional: true }),
                    style({ opacity: 0 }),
                    animate('450ms 400ms cubic-bezier(0.42, 0, 1, 1)', style({ opacity: 1 })),
                    query('.animate-content:not(.dont-animate-content .animate-content)', content_enter_up, {
                        optional: true,
                    }),

                    query('.animate-header:not(.dont-animate-header .animate-header)', header_enter_up, {
                        optional: true,
                    }),
                    query(
                        '.premium-section:not(.dont-animate-banner .premium-section)',
                        [
                            style({ width: '', transform: 'translateY(-50px)' }),
                            animate(
                                '450ms 400ms cubic-bezier(0.42, 0, 1, 1)',
                                style({
                                    transform: 'translateX(0)',
                                    width: '',
                                })
                            ),
                        ],
                        { optional: true }
                    ),
                ]),
                { optional: true }
            ),
            query(
                ':leave',
                group([
                    style({ opacity: 1 }),
                    animate('300ms cubic-bezier(0.42, 0, 0.58, 1)', style({ opacity: 0 })),
                    query('.animate-content:not(.dont-animate-content .animate-content)', content_leave_dn, {
                        optional: true,
                    }),

                    query('.animate-header:not(.dont-animate-header .animate-header)', header_leave_dn, {
                        optional: true,
                    }),
                    query(
                        '.premium-section:not(.dont-animate-banner .premium-section)',
                        [
                            style({ transform: 'translateY(0)', width: '' }),
                            animate(
                                '300ms cubic-bezier(0.42, 0, 0.58, 1)',
                                style({
                                    transform: 'translateY(-50px)',
                                    width: '',
                                })
                            ),
                        ],
                        { optional: true }
                    ),

                    query('@*', animateChild(), { optional: true }),
                ]),
                { optional: true }
            ),
        ]),
    ]),
]);

export const cardsRouteAnimation = trigger('cardsAnimation', [
    transition('* <=> *', [
        query(':enter', style({ opacity: 0, transform: 'translateY(100px)' }), { optional: true }),

        query(
            ':enter',
            stagger('25ms', [
                animate('450ms 400ms cubic-bezier(0.42, 0, 1, 1)', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            {
                optional: true,
            }
        ),

        query(':leave', style({ opacity: 1, transform: 'translateY(0)' }), { optional: true }),

        query(
            ':leave',
            stagger('100ms', [
                animate('.1s cubic-bezier(0.42, 0, 0.58, 1)', style({ opacity: 0, transform: 'translateY(50px)' })),
            ]),
            { optional: true }
        ),
    ]),
]);

export const opacityTrigger = trigger('opacityAnimation', [
    transition('* <=> *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),

        query(
            ':enter',
            animate(
                '450ms cubic-bezier(0.42, 0, 1, 1)',
                style({
                    opacity: '1',
                })
            ),
            { optional: true }
        ),
        query(
            ':leave',
            animate(
                '300ms cubic-bezier(0.42, 0, 0.58, 1)',
                style({
                    opacity: '0',
                })
            ),
            { optional: true }
        ),
    ]),
]);
